import React, { useEffect, useState } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { EmotionalSection } from './components/EmotionalSection';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProductSection } from './components/ProductSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueSection } from './components/ValueSection';
import { TransformationSection } from './components/TransformationSection';
import { ForYouSection } from './components/ForYouSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyBuyBar } from './components/StickyBuyBar';
import { Modal } from './components/Modal';
import { legalContent } from './data/content';
type ModalKey = 'privacy' | 'terms' | null;
export function App() {
  const [modal, setModal] = useState<ModalKey>(null);
  useEffect(() => {
    initMetaPixel();
  }, []);
  const active = modal ? legalContent[modal] : null;
  return <div className="w-full bg-ivory font-sans text-ink" data-id="element-0" data-mp="82j0zgp5o9c">
      <main data-id="element-1" data-mp="2zm4xcjfp5b1a">
        <Hero data-id="element-2" data-mp="2zmo557bmuj1l" />
        <EmotionalSection data-id="element-3" data-mp="2zmwlj96ys6hj" />
        <ProblemSection data-id="element-4" data-mp="33mowfsjtyoq2" />
        <MethodSection data-id="element-5" data-mp="33lwzadal4ixo" />
        <BenefitsSection data-id="element-6" data-mp="33n6zp94wu37h" />
        <ProductSection data-id="element-7" data-mp="33orla998ybt7" />
        <BonusesSection data-id="element-8" data-mp="38m1e7yvuh5ls" />
        <ValueSection data-id="element-9" data-mp="38kqc03i1s5ws" />
        <TransformationSection data-id="element-10" data-mp="38k6wetfvdtlx" />
        <ForYouSection data-id="element-11" data-mp="3dkuuu06fhcq6" />
        <TestimonialsSection data-id="element-12" data-mp="3dle3sre3oqs2" />
        <GuaranteeSection data-id="element-13" data-mp="3dlnwwnufze1z" />
        <FaqSection data-id="element-14" data-mp="3diry6xarslch" />
        <FinalCta data-id="element-15" data-mp="nvsvh92bsvy2" />
      </main>

      <Footer onOpenTerms={() => setModal('terms')} onOpenPrivacy={() => setModal('privacy')} data-id="element-16" data-mp="nuhhyhj2w9tr" />

      <StickyBuyBar data-id="element-17" data-mp="stkn01z26g1q" />

      <Modal open={modal !== null} onClose={() => setModal(null)} title={active?.title ?? ''} paragraphs={active?.paragraphs ?? []} data-id="element-18" data-mp="st2hsfuf4rho" />
    </div>;
}